import React from 'react'

const JS_Essentials_Coding_Pratice_8 = () => {
  return (
    <div>
      <h1>Coding Practice 8</h1>
    </div>
  )
}

export default JS_Essentials_Coding_Pratice_8
